import { useContext } from "react";
import {ThemeContext} from './context'
import About from "./components/about/About";
import Contact from "./components/contact/Contact";
import Intro from "./components/intro/Intro";
import ProductList from "./components/product/ProductList";
import Toggle from './components/toggle/Toggle'

function App() {


  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode ;

  return (
    <div className="App" style={{ background: darkMode ?  "#222" : "white", color: darkMode && "white" }}>
<Toggle />
      <Intro />
      <About />
      <ProductList />
      <Contact />
    </div>
  );
}

export default App;
